import { Directive, HostBinding, Input, OnInit } from '@angular/core';

@Directive({ selector: '[muloElementAsHeading]', standalone: true })
export class ElementAsHeadingDirective implements OnInit {
  @HostBinding('role') role = 'heading';
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @HostBinding('attr.aria-level') @Input('muloElementAsHeading') headingLevel;

  ngOnInit() {
    if (this.headingLevel == null || this.headingLevel <= 0) {
      this.headingLevel = undefined;
      this.role = undefined;
    }
  }
}
